module.exports = __webpack_public_path__ + "img/hp-case-blue.c2880bdb.png";